// Module
var code = "<mn-summary-item ng-repeat=\"summary in vm.summaryFile track by $index\" summary=\"summary\" class=\"flex-noshrink no-margin\"></mn-summary-item>";
// Exports
module.exports = code;